import * as types from './types';

export default {

  async setSchoolByCode({dispatch, commit}, sitecode) {
    const school = await dispatch('fetchSchool', sitecode);
    commit('setSchool', school);
  },

  async setSchool({dispatch, commit}, school) {
    commit('setSchool', school);
    await dispatch('fetchDeviceCount', school.site_code);
  },

  async fetchSchool({dispatch}, sitecode) {
    return await dispatch('api', {
      method: 'GET',
      url: `/schools/${sitecode}`,
      types: [
        types.SCHOOL_REQUEST,
        types.SCHOOL_SUCCESS,
        types.SCHOOL_FAILURE,
      ]
    });
  },

  async searchSchool({dispatch}, query, limit = 10) {
    let url = '/schools/';
    if (query) {
      const filteredQuery = query.replace(/[^\w\s]/g, "");
      url = `/schools/?query=${filteredQuery}&limit=${limit}`;
    } else {
      url = `/schools/?limit=${limit}`;
    }
    return await dispatch('api', {
      method: 'GET',
      url: url,
      types: [
        types.SCHOOL_SEARCH_REQUEST,
        types.SCHOOL_SEARCH_SUCCESS,
        types.SCHOOL_SEARCH_FAILURE,
      ]
    })
  },

  async fetchChildSchools({dispatch}, {siteId}) {
    return await dispatch('api', {
      method: 'GET',
      url: `/schools/childschools/${siteId}`,
      types: [
        types.SCHOOL_CHILD_SCHOOLS_REQUEST,
        types.SCHOOL_CHILD_SCHOOLS_SUCCESS,
        types.SCHOOL_CHILD_SCHOOLS_FAILURE,
      ]
    });
  },
}
